<template>
  <div>
    <v-dialog v-model="mostrar" persistent width="500">
      <v-snackbar
          absolute
          v-model="snackbar.active"
          :color="snackbar.color"
          :top="true"
      >
        {{ snackbar.message }}
        <v-btn dark text @click="snackbar.active = false">
          Fechar
        </v-btn>
      </v-snackbar>
      <v-card>
        <v-card-title>
          Trocando a senha de {{usuario.nome}}
        </v-card-title>
        <v-card-text>
          <v-form ref="trocarSenhaForm">
            <v-text-field
                ref="new-password"
                v-model="senha"
                :rules="[rules.required, rules.min]"
                :append-icon=" showAppendSenha ? 'mdi-eye' : 'mdi-eye-off'"
                name="input-10-1"
                :type=" showAppendSenha ? 'text' : 'password'"
                label="Nova senha"
                counter
                outlined
                autocomplete="password"
                @click:append="showAppendSenha = !showAppendSenha"
            />

            <v-text-field
                v-model="senhaRepetida"
                :append-icon=" showAppendSenhaRepetida ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="[() => !!senhaRepetida || 'Digite a nova senha novamente!', rules.igual]"
                name="input-10-1"
                :type=" showAppendSenhaRepetida ? 'text' : 'password'"
                label="Repita a senha"
                counter
                outlined
                autocomplete="password"
                @click:append="showAppendSenhaRepetida = !showAppendSenhaRepetida"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn :disabled="salvando" color="error" text @click="fechar()">FECHAR</v-btn>
          <v-btn style="text-align: right" color="green" @click="trocarSenha" :loading="salvando" :dark="true">
            SALVAR
          </v-btn>
        </v-card-actions>
      </v-card>

    </v-dialog>
  </div>
</template>

<script>
import UserService from "@/service/UserService";

export default {
  name: "TrocarSenha",
  props: {
    usuario: Object,
    mostrar: Boolean,
    fechar: Function,
    sucesso: Function
  },
  data() {
    return {
      snackbar: {
        message: "",
        color: "",
        active: ""
      },
      senhaAtual: "",
      senha: "",
      senhaRepetida: "",
      showAppendSenhaAtual: false,
      showAppendSenhaRepetida: false,
      showAppendSenha: false,
      salvando: false,
      rules: {
        required: value => !!value || "Campo Requerido",
        min: v => (v ? v.length >= 6 || "Min 6 characters" : "" >= 6 || "Min 6 characters"),
        igual: () =>
            this.senha == this.senhaRepetida || "Senhas não são iguais",
      },
    }
  },
  methods: {
    trocarSenha() {
      if(this.$refs.trocarSenhaForm.validate()) {

        let trocarSenha = {
          idUsuario: this.usuario.id,
          senhaAtual: this.senhaAtual,
          novaSenha: this.senha,
          senhaRepetida: this.senhaRepetida
        }

        this.salvando = true;

        UserService.trocarSenhaTerceiro(trocarSenha)
            .then(() => {
              this.sucesso();
            })
            .catch(() => {
              this.snackbar.color = "red";
              this.snackbar.message = "Erro ao trocar senha do usuário!";
              this.snackbar.active = true;
            })
            .finally(() => {
              this.salvando = false;
            });
      }
    }
  },
  watch: {
    mostrar() {
      if(this.mostrar) {
        this.senha = "";
        this.senhaAtual = "";
        this.senhaRepetida = "";
        if(this.$refs.trocarSenhaForm)
          this.$refs.trocarSenhaForm.reset();
      }

    }
  }
}

</script>